// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--sl-tier-const-sty-box{
    width: 100%;
    height: auto;
}

.scl--sl-main-title-set{
    height: 58px;
    border-bottom: 1px solid rgba(226, 232, 240, 1);
    margin-top: 10px;
    padding-left: 5px;
}

.scl--sl-main-title-set h4{
    color: var(--typography-text-body-primary);
    margin: 0;
    font-family: var(--font-family-inter);
    font-weight: bold;
    font-size: 20px;
    padding: 0px 0px 4px 0px;
}

.scl--sl-main-title-set p{
    color: var(--typography-text-body-secondary);
    font-family: var(--font-family-inter);
    padding: 0;
    margin: 0;
    font-size: 12px;
}

.scl--sl-items-set-tier{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 15px 0px 15px 15px;
    border-bottom: 1px solid rgba(226, 232, 240, 1);
}

.scl--sl-single-item-set-tier-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.scl--sl-single-set-tier-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5px;
}

.scl--sl-single-set-tier-container h6{
    color: var(--typography-text-body-primary);
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-family: var(--font-family-inter);
    font-weight: normal;
}

.scl--sl-single-set-tier-container p{
    color: var(--typography-text-body-secondary);
    padding: 0;
    margin: 0;
    font-family: var(--font-family-inter);
    font-size: 12px;
}

.scl--sl-items-set-tier .scl--sl-single-item-set-btn-const .scl-components-toggle-RoundSwitchButton-on{
    background: var(--secondarycolors-blue400);
}

.scl--sl-tier-const-sty-box:last-of-type .scl--sl-items-set-tier{
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/list-fs-cp/media-list-op/css/setting-list-tier.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,+CAA+C;IAC/C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,SAAS;IACT,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,SAAS;IACT,eAAe;IACf,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,UAAU;IACV,SAAS;IACT,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".scl--sl-tier-const-sty-box{\n    width: 100%;\n    height: auto;\n}\n\n.scl--sl-main-title-set{\n    height: 58px;\n    border-bottom: 1px solid rgba(226, 232, 240, 1);\n    margin-top: 10px;\n    padding-left: 5px;\n}\n\n.scl--sl-main-title-set h4{\n    color: var(--typography-text-body-primary);\n    margin: 0;\n    font-family: var(--font-family-inter);\n    font-weight: bold;\n    font-size: 20px;\n    padding: 0px 0px 4px 0px;\n}\n\n.scl--sl-main-title-set p{\n    color: var(--typography-text-body-secondary);\n    font-family: var(--font-family-inter);\n    padding: 0;\n    margin: 0;\n    font-size: 12px;\n}\n\n.scl--sl-items-set-tier{\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    padding: 15px 0px 15px 15px;\n    border-bottom: 1px solid rgba(226, 232, 240, 1);\n}\n\n.scl--sl-single-item-set-tier-box{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.scl--sl-single-set-tier-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 5px;\n}\n\n.scl--sl-single-set-tier-container h6{\n    color: var(--typography-text-body-primary);\n    padding: 0;\n    margin: 0;\n    font-size: 16px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n}\n\n.scl--sl-single-set-tier-container p{\n    color: var(--typography-text-body-secondary);\n    padding: 0;\n    margin: 0;\n    font-family: var(--font-family-inter);\n    font-size: 12px;\n}\n\n.scl--sl-items-set-tier .scl--sl-single-item-set-btn-const .scl-components-toggle-RoundSwitchButton-on{\n    background: var(--secondarycolors-blue400);\n}\n\n.scl--sl-tier-const-sty-box:last-of-type .scl--sl-items-set-tier{\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
